import React, { useState, useEffect } from "react";
import {
  toggleCompanyForm,
  toggleCompanyFormYear1,
  toggleCompanyFormYear2,
  toggleCompanyFormYear3,
} from "../../Redux/Actions/activeCompanyForm";
import { useSelector, useDispatch } from "react-redux";
import { useAuth } from "../../Context/AuthContext";

const CompanyFormButton = () => {
  const { salaryCalculationData, editCompanyForm } = useAuth();
  const [currentCompanyForm, setCurrentCompanyForm] = useState("enskildFirma");
  const activeYear = useSelector((state) => state.year);

  const dispatch = useDispatch();

  const businessHandler = (value) => {
    if (activeYear.year === "year1") {
      dispatch(toggleCompanyFormYear1(value));
      editCompanyForm({ companyFormYear1: value });
    }
    if (activeYear.year === "year2") {
      dispatch(toggleCompanyFormYear2(value));
      editCompanyForm({ companyFormYear2: value });
    }
    if (activeYear.year === "year3") {
      dispatch(toggleCompanyFormYear3(value));
      editCompanyForm({ companyFormYear3: value });
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      if (activeYear.year === "year1") {
        salaryCalculationData &&
          salaryCalculationData.map((item) =>
            setCurrentCompanyForm(item.object.activeCompany.companyFormYear1)
          );
        dispatch(toggleCompanyForm(currentCompanyForm));
      }
      if (activeYear.year === "year2") {
        salaryCalculationData &&
          salaryCalculationData.map((item) =>
            setCurrentCompanyForm(item.object.activeCompany.companyFormYear2)
          );
        dispatch(toggleCompanyForm(currentCompanyForm));
      }
      if (activeYear.year === "year3") {
        salaryCalculationData &&
          salaryCalculationData.map((item) =>
            setCurrentCompanyForm(item.object.activeCompany.companyFormYear3)
          );
        dispatch(toggleCompanyForm(currentCompanyForm));
      }
    }
    return () => {
      isMounted = false;
    };
  }, [activeYear.year, currentCompanyForm, dispatch, salaryCalculationData]);

  return (
    <div className="container-company-form-button-mobile">
      <div
        className={`${
          currentCompanyForm === "enskildFirma"
            ? "company-form-button-mobile-focused"
            : "company-form-button-mobile"
        }`}
        onClick={() => {
          businessHandler("enskildFirma");
        }}
      >
        Enskild Firma
      </div>

      <div
        className={`${
          currentCompanyForm === "aktiebolag"
            ? "company-form-button-mobile-focused"
            : "company-form-button-mobile"
        }`}
        onClick={() => {
          businessHandler("aktiebolag");
        }}
      >
        Aktiebolag
      </div>
    </div>
  );
};
export default CompanyFormButton;
